/*
 * A function to recursively traverse the strings.json file
 *
 * It is used to map the en_US json structure to other languages
 * The callback is called at each non-object node of the original
 * This preserves the original structure of the input json.
 */
const recurse = function(node, output, callback, keyStack) {
  keyStack = keyStack || []
  Object.keys(node).forEach(function(key) {
    keyStack.push(key)
    if (typeof node[key] === 'object') {
      output[key] = {}
      recurse(node[key], output[key], callback, keyStack)
    } else {
      callback(node[key], output, key, keyStack)
    }
    keyStack.pop()
  })
}

export default {
  recurse
}
